import { render, staticRenderFns } from "./HubPostsTable.vue?vue&type=template&id=5d19fe60&scoped=true&"
import script from "./HubPostsTable.vue?vue&type=script&lang=js&"
export * from "./HubPostsTable.vue?vue&type=script&lang=js&"
import style0 from "./HubPostsTable.vue?vue&type=style&index=0&id=5d19fe60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19fe60",
  null
  
)

export default component.exports